import {
  VEHICLES_CLEAR_ERROR,
  VEHICLES_FETCH_FAIL,
  VEHICLES_FETCH_REQUEST,
  VEHICLES_FETCH_SUCCESS,
} from "../constants/VehicleConstants";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

export const VehicleReducer = (state = initialState, action) => {
  switch (action.type) {
    case VEHICLES_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case VEHICLES_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload || [],
      };
    case VEHICLES_FETCH_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case VEHICLES_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
